import { Currency } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import FormattedTimeZone from '@swf/components/FormattedTimeZone/FormattedTimeZone';
import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { PreCashinInfo } from '../../../../../../../types/Cashier';

import {
  TXTCLI_XbXYou_may_continue_to_make_de_ELL,
  TXTCLI_You_may_continue_to_make_depos_ELL
} from './QualifyDeposits.messages.json';
import DefaultDeposits from './components/DefaultDeposits/DefaultDeposits';
import LastQualifyDeposit from './components/LastQualifyDeposit/LastQualifyDeposit';

const QualifyDeposits: React.FC = () => {
  const {
    data: { preCashinInfo }
  } = useWizardContext();

  const {
    bonusMax,
    bonusEnd,
    bonusPercent,
    bonusCurrency,
    lastAllowedDepositTime,
    maxNumberOfDepositsLeft
  } = preCashinInfo as PreCashinInfo;

  const bonusMaxFormatted = <CurrencyAmount value={bonusMax} currency={Currency[bonusCurrency]} />;
  const formattedDate = (
    <FormattedTimeZone
      date={lastAllowedDepositTime || bonusEnd}
      month="short"
      day="2-digit"
      year="numeric"
      hour="numeric"
      minute="numeric"
      timeZoneName="short"
      hour12={false}
    />
  );

  if (maxNumberOfDepositsLeft === -1) {
    return (
      <Translation
        tagName="p"
        {...(!lastAllowedDepositTime
          ? TXTCLI_XbXYou_may_continue_to_make_de_ELL
          : TXTCLI_You_may_continue_to_make_depos_ELL)}
        values={{
          0: bonusMaxFormatted,
          1: bonusPercent,
          2: formattedDate
        }}
      />
    );
  } else if (maxNumberOfDepositsLeft === 1) {
    return (
      <LastQualifyDeposit bonusMaxFormatted={bonusMaxFormatted} formattedDate={formattedDate} />
    );
  }

  return <DefaultDeposits />;
};

export default QualifyDeposits;
